module.exports = __webpack_public_path__ + "static/media/intro-video-thumbnail.06bcbea4.png";